import { render, staticRenderFns } from "./OrderResearch.vue?vue&type=template&id=57239d9a&scoped=true&"
import script from "./OrderResearch.vue?vue&type=script&lang=js&"
export * from "./OrderResearch.vue?vue&type=script&lang=js&"
import style0 from "./OrderResearch.vue?vue&type=style&index=0&id=57239d9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57239d9a",
  null
  
)

export default component.exports